import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import noop from 'lodash/noop';
import merge from 'lodash/merge';
import {
    ORIGIN_TOP_RIGHT,
    ORIGIN_BOTTOM_RIGHT,
    SIZE_AUTO,
    SuiContainer,
    SuiPopoverMenu,
    SuiButton,
} from '@splashthat/sui';
import MenuVertical from 'common/icons/MenuVertical';

const POPOVER_BUTTON_ARIA_LABEL = 'Open Menu';

const TridotStyle = styled.div`
    align-self: center;
    ${({ isTouchPoint }) =>
        isTouchPoint &&
        `
        {
            top: 1rem;
            right: 1rem;
            position: absolute;
        }
    `}
    .SuiPopoverButton {
        width: 100%;

        & > div:last-child {
            display: none;
        }
    }
`;

const OverflowLabel = styled.div`
    padding: 8px;
    font-size: 0.8rem;
    font-weight: bold;
`;

const StyledIcon = styled(MenuVertical)`
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.25rem;
    color: ${({ theme }) => theme.palette.grayscale.black};

    &:hover {
        color: ${({ theme }) => theme.palette.primary.main};
    }

    &:focus {
        color: ${({ theme }) => theme.palette.primary.main};
    }
`;

const TridotOption = ({ icon, options, onRequestClose, popoverProps, qaId, isTouchPoint, ariaLabel, ...props }) => {
    const defaultPopoverProps = {
        targetOrigin: ORIGIN_TOP_RIGHT,
        targetWidth: SIZE_AUTO,
        targetHeight: SIZE_AUTO,
        anchorOrigin: ORIGIN_BOTTOM_RIGHT,
        onRequestClose,
    };
    const combinedPopoverProps = merge(defaultPopoverProps, popoverProps);
    const hasOptions = options && options.length > 0;

    const onClickIcon = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <TridotStyle isTouchPoint={isTouchPoint} qaId={qaId} data-qa={`overflow-menu--${qaId}`} {...props}>
            <SuiPopoverMenu
                buttonElement={
                    <SuiButton variation="text" aria-label={ariaLabel} onClick={onClickIcon} icon={<StyledIcon />} />
                }
                popoverProps={combinedPopoverProps}
            >
                {hasOptions &&
                    options.map((item) => (
                        <SuiContainer
                            key={item.label}
                            onClick={(e, ...args) => {
                                e.stopPropagation();
                                return item.onClick(e, ...args);
                            }}
                        >
                            <OverflowLabel>{item.label}</OverflowLabel>
                        </SuiContainer>
                    ))}
            </SuiPopoverMenu>
        </TridotStyle>
    );
};

TridotOption.propTypes = {
    icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.any,
            onClick: PropTypes.func,
        }),
    ),
    onRequestClose: PropTypes.func,
    popoverProps: PropTypes.object,
    children: PropTypes.node,
    qaId: PropTypes.string.isRequired,
    isTouchPoint: PropTypes.bool,
    ariaLabel: PropTypes.string,
};

TridotOption.defaultProps = {
    icon: MenuVertical,
    options: null,
    onRequestClose: noop,
    popoverProps: {},
    children: null,
    isTouchPoint: false,
    ariaLabel: POPOVER_BUTTON_ARIA_LABEL,
};

export default TridotOption;
